module.exports = __webpack_public_path__ + "img/screen-1.6440b2a9.png";